import { Burger, Group, Image, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import logo from '../../../asset/logo.png';
import { Constant } from "../../../models/constant";
import { User } from "../../../models/user";
import ColorSchemeButton from "../ColorSchemeButton/ColorSchemeButton";

export interface IHeaderProps {
  toggleLeftSideVisible: (visible: boolean) => void;
}
function Header(props: IHeaderProps) {
  const [leftSideVisible, { toggle: toggleLeftSideVisible }] = useDisclosure();
  const [user, setUser] = useState<User>();
  const navigate = useNavigate();

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem(Constant.LS_USER_KEY)!));
  }, [])

  useEffect(() => {
    props.toggleLeftSideVisible(leftSideVisible);
  }, [leftSideVisible])

  return (
    <Stack gap={0}>
      <Group h="60" p="8" justify="space-between">
        <Group h={'100%'}>
          <Group h={'100%'}>
            <Burger opened={leftSideVisible} onClick={toggleLeftSideVisible} hiddenFrom="sm" size="sm" />
            <Image src={logo} fit="contain" h={'70%'} w={'auto'} onClick={() => navigate("/")} style={{ cursor: 'pointer' }} hiddenFrom="sm" />
            <Image src={logo} fit="contain" h={'100%'} w={'auto'} onClick={() => navigate("/")} style={{ cursor: 'pointer' }} visibleFrom="sm" />
          </Group>
        </Group>
        <Group justify="flex-end" h={'100%'} visibleFrom="sm">
          {user && <><Text>Benvenuto, <b>{user.firstName} {user.lastName}</b></Text> {/*<Button variant="outline" color="gray" onClick={onLogoutClick}>Logout</Button>*/}</>}
          <ColorSchemeButton />
        </Group>
      </Group>
    </Stack>
  );
}

export default Header;